import { useState, useEffect } from 'react';
import fetch from 'unfetch';
import {
  getRuntimeEnvVariables,
} from 'helpers/Utils';
import useInterval from './useInterval';
import useTimeout from './useTimeout';

export function getURL({ key, postLoginOpToken }) {
  let serverURL = '';
  let queryParams = '';
  if (postLoginOpToken) {
    queryParams = `?postLoginOpToken=${encodeURIComponent(postLoginOpToken)}`;
  }

  if (typeof window !== 'undefined') {
    serverURL = process.env.NODE_ENV === 'development'
      ? getRuntimeEnvVariables('RUNTIME_CLIENT_SERVER_URL')
      : window?.location?.origin;
  }

  const SERVER_LOGIN_URLS = {
    check: `${serverURL}/login/check`,
    google: `${serverURL}/login/social/google${queryParams}`,
    facebook: `${serverURL}/login/social/facebook${queryParams}`,
  };

  return SERVER_LOGIN_URLS[key];
}

export function fetchStatus({
  onSuccess, onError,
}) {
  fetch(getURL({ key: 'check' }), {
    credentials: 'include',
  }).then(res => res.json())
    .then(response => {
      onSuccess(response);
    }).catch(() => {
      onError();
    });
}

/**
 * @param {String} URL - server URL to check login status
 * @param {String} initialStatus - initial user status (LOGGED_OUT)
 * @param {Function} onSuccess - callback,
 * to call when user status is different from {initialStatus}
 * @param {Function} onError - callback, to call on timeout or server errors
 */
function useLoginStatusCheckPolling({
  initialStatus,
  EmailRegistrationStatus,
  onSuccess,
  onEmailRegistration,
  onTimeout,
  onError,
}) {
  const [isCheckStatusRunning, setIsCheckStatusRunning] = useState(false);
  const CHECK_LOGIN_STATUS_TIMEOUT = 300000;
  const CHECK_LOGIN_STATUS_DELAY = 3000;

  const getStatus = () => fetchStatus({
    onSuccess: (response) => {
      if (response?.type !== initialStatus) {
        if (response?.type === EmailRegistrationStatus) {
          setIsCheckStatusRunning(false);
          onEmailRegistration(response);
        } else {
          setIsCheckStatusRunning(false);
          onSuccess(response);
        }
      }
    },
    onError: () => {
      setIsCheckStatusRunning(false);
      onError();
    },
  });

  isCheckStatusRunning && getStatus();
  useInterval(getStatus, isCheckStatusRunning ? CHECK_LOGIN_STATUS_DELAY : null);
  useTimeout(() => {
    setIsCheckStatusRunning(false);
    onTimeout();
  }, isCheckStatusRunning ? CHECK_LOGIN_STATUS_TIMEOUT : null);

  return [setIsCheckStatusRunning];
}

export function useLoginStatusCheck() {
  const [userStatus, setUserStatus] = useState();

  useEffect(() => {
    async function checkStatus() {
      await fetchStatus({
        onSuccess: (response) => setUserStatus(response.type),
        onError: () => { throw new Error(); },
      });
    }

    checkStatus();
  }, []);

  return [userStatus];
}

export default useLoginStatusCheckPolling;
